<template>
	<div class="iphoneBottomHeight">
		
	</div>
</template>

<script>
	export default {
		name:"IPhoneBottomHeight",
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="less">
.iphoneBottomHeight {
       height: constant(safe-area-inset-bottom);
       height: env(safe-area-inset-bottom);
     }
</style>



// WEBPACK FOOTER //
// src/components/IPhoneBottomHeight.vue